var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/add_project"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.44 3.837h6.534a2.447 2.447 0 0 1 2.446 2.447v3.379M6 15h6m-3-3v6m8.854 3H6.146A3.146 3.146 0 0 1 3 17.854V6.146A3.146 3.146 0 0 1 6.146 3h3.533c.883 0 1.686.512 2.059 1.312l1.485 4.025h4.631A3.146 3.146 0 0 1 21 11.483v6.371A3.146 3.146 0 0 1 17.854 21Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProject);
export default __webpack_public_path__ + "static/media/add_project.9a5b5471cb398ee94d77d2230a3fbaa3.svg";
export { ForwardRef as ReactComponent };